var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var BaseContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background: ", ";\n  padding: 7rem 0 3rem;\n  min-height: calc(100vh - 7rem);\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background: ", ";\n  padding: 7rem 0 3rem;\n  min-height: calc(100vh - 7rem);\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.silver;
});
var templateObject_1;
